import "./SearchButton.scss";
import cn from "classnames";
import { MagnifyingGlassIcon, XCloseIcon } from "/App.Components";

interface SearchButtonProps {
  style: "primary" | "secondary" | "disabled";
  openLabel: string;
  closeLabel?: string;
  isOpen: boolean;
  onClick?: () => void;
}

/**
 * Primary UI component for user interaction
 */
const SearchButton = ({
  style,
  openLabel,
  closeLabel,
  isOpen,
  onClick,
}: SearchButtonProps) => (
  <button
    onClick={onClick ? onClick : undefined}
    className={cn("search-button-norad", `search-button-norad--${style}`)}
  >
    <span className="search-button-norad__label">
      {!isOpen ? openLabel : closeLabel}
    </span>
    {!isOpen ? (
      <MagnifyingGlassIcon size="24" thickness="Reg" />
    ) : (
      <XCloseIcon size={"24"} thickness={"Reg"} />
    )}
  </button>
);
export default SearchButton;
